<template>
	<div id='app' style='position: relative; padding-top: 12px; padding-bottom: 24px'>
		<Loader ref='loader' />
		<router-view style='max-width: 1000px' />
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import Loader from '@/components/Loader';
import functions from '@/mixins/functions';

export default {
	name: `App`,
	components: { Loader },
	mixins: [functions],
	async mounted () {
		const { states, countries, csrf_token, ...config } = await this.request({ action: `get_config` });
		const { $store } = this;
		$store.commit(`saveCountries`, { states, countries });
		$store.commit(`saveConfig`, { csrf: csrf_token, ...config });
		this.getMe();
	},
	methods: { ...mapActions([`getMe`]) }
};
</script>

<style>
html {
	height: unset;
}
#ppMain {
	background: transparent;
}
</style>

<style lang='scss' scoped>
#app {
	font-family: 'Roboto', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: transparent;
}
</style>